import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import type { CrudFilter } from "@refinedev/core";
import React, { useEffect, useState } from "react";

type SearchFieldProps = {
  placeholder: string;
  buildFilters: (query: string) => CrudFilter[];
  onSearch: (filters: CrudFilter[]) => void;
  debounceMs?: number;
};

/**
 * Debounced search input, isolated so each keystroke re-renders only this
 * field and not the surrounding List + DataGrid (which is what made typing
 * lag). Pass a stable `buildFilters` (module-level const) and `onSearch`
 * (refine's `setFilters`) so the debounce effect isn't reset on every render.
 */
export const SearchField: React.FC<SearchFieldProps> = ({
  placeholder,
  buildFilters,
  onSearch,
  debounceMs = 300,
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const t = setTimeout(() => onSearch(buildFilters(value)), debounceMs);
    return () => clearTimeout(t);
  }, [value, buildFilters, onSearch, debounceMs]);

  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
    />
  );
};
